import { render, staticRenderFns } from "./Build.vue?vue&type=template&id=6d945c77&scoped=true"
import script from "./Build.vue?vue&type=script&lang=js"
export * from "./Build.vue?vue&type=script&lang=js"
import style0 from "./Build.vue?vue&type=style&index=0&id=6d945c77&prod&lang=scss&scoped=true"
import style1 from "./Build.vue?vue&type=style&index=1&id=6d945c77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d945c77",
  null
  
)

export default component.exports